// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-LanguageSwitch-module--cls1--3Wxj0","cls2":"styles-LanguageSwitch-module--cls2--P0DdX styles-LanguageSwitch-module--cls1--3Wxj0"};